import * as React from 'react'

import { cn } from '@/lib/utils'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const FloatingInput = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, ...props }, ref) => {
    return (
      <Input
        className={cn(
          'peer h-12 border-border text-foreground focus:border-input hover:border-input',
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)

FloatingInput.displayName = 'FloatingInput'

const FloatingLabel = React.forwardRef<
  React.ElementRef<typeof Label>,
  React.ComponentPropsWithoutRef<typeof Label>
>(({ className, ...props }, ref) => {
  return (
    <Label
      className={cn(
        'absolute left-2 -top-2.5 z-10 bg-card px-2 sm:text-sm text-muted-foreground transition-all text-xs',
        'peer-placeholder-shown:top-4 sm:peer-placeholder-shown:text-sm peer-placeholder-shown:text-muted-foreground',
        'peer-focus:-top-2.5 sm:peer-focus:text-sm peer-focus:text-muted-foreground',
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
FloatingLabel.displayName = 'FloatingLabel'

type FloatingLabelInputProps = InputProps & { label?: string }

const FloatingLabelInput = React.forwardRef<
  React.ElementRef<typeof FloatingInput>,
  React.PropsWithoutRef<FloatingLabelInputProps>
>(({ id, label, ...props }, ref) => {
  return (
    <div className='relative w-full'>
      <FloatingInput ref={ref} id={id} placeholder='' {...props} />
      <FloatingLabel htmlFor={id}>{label}</FloatingLabel>
    </div>
  )
})
FloatingLabelInput.displayName = 'FloatingLabelInput'

export { FloatingInput, FloatingLabel, FloatingLabelInput }
